import { Box, Text } from '@factorialco/deprecated-design-system'

interface SectionTitleProps {
  description?: string
  title: string
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ description, title }) => {
  return (
    <Box>
      <Text size="300" color="grey1000" weight="bold">
        {title}
      </Text>
      {description && (
        <Text size="300" color="grey1000" weight="normal">
          {description}
        </Text>
      )}
    </Box>
  )
}
